import { cn } from "@/lib/cn";
import type { ReactNode } from "react";

/**
 * PageHeader — encabezado de pantalla con título serif (eyebrow opcional),
 * descripción y acciones a la derecha. Mobile-first: en pantallas chicas el
 * bloque de acciones baja debajo del título.
 */
export function PageHeader({
  eyebrow,
  title,
  description,
  actions,
  className,
}: {
  eyebrow?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <header
      className={cn(
        "flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between",
        className,
      )}
    >
      <div className="space-y-1.5">
        {eyebrow && (
          <p className="text-xs font-medium uppercase tracking-[0.14em] text-clay-strong">
            {eyebrow}
          </p>
        )}
        <h1 className="font-display text-2xl leading-tight text-ink sm:text-3xl">
          {title}
        </h1>
        {description && (
          <p className="max-w-2xl text-sm text-ink-muted sm:text-[0.95rem]">
            {description}
          </p>
        )}
      </div>
      {actions && (
        <div className="flex shrink-0 items-center gap-2">{actions}</div>
      )}
    </header>
  );
}
